export default "__VITE_ASSET__EXN1mG94__"